import React from 'react';
import { useNavigate } from 'react-router-dom';

const Lrn_us_mat_pcard = ({ title, description, path, icon }) => {
  const navigate = useNavigate();

  return (
    <div
      onClick={() => navigate(path)}
      className="group cursor-pointer rounded-xl border border-gray-200 bg-white p-6 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:border-blue-500 hover:shadow-lg"
    >
      <div className="flex items-center space-x-4">
        {icon && (
          <div className="flex h-12 w-12 items-center justify-center rounded-lg bg-blue-50 text-blue-600 transition-colors group-hover:bg-blue-600 group-hover:text-white">
            {icon}
          </div>
        )}
        <div>
          <h3 className="text-lg font-semibold text-gray-800 group-hover:text-blue-600">
            {title}
          </h3>
          <p className="mt-1 text-sm text-gray-500">{description}</p>
        </div>
      </div>
    </div>
  );
};

export default Lrn_us_mat_pcard;